module.exports = "/fonts/vendor/boxicons/boxicons.ttf?878061312a371566f591f1f1a9f76a87";